import emailjs from "@emailjs/browser";

const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL;
const BRAND_NAME = process.env.REACT_APP_BRAND_NAME || "Sky High NTB";
const BASE_URL = process.env.REACT_APP_BASE_URL || "https://skyhighntb.com";

const generateDepositNotificationHTML = (userData, paymentDetails) => {
  const adminLink = `${BASE_URL}/userdetail/${userData.uid}`;
  const amount = typeof paymentDetails.amount === 'number' ? paymentDetails.amount.toFixed(2) : paymentDetails.amount;
  
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <style>
        .header { background: linear-gradient(to right, #8b0000, #dc143c); color: #ffffff; padding: 20px; text-align: center; border-radius: 10px 10px 0 0; }
        .content { padding: 10px; color: #333; }
        .info-box { background: #f8f9fa; padding: 20px; border-radius: 8px; margin: 20px 0; }
        .info-box p { margin: 12px 0; }
        .label { font-weight: bold; color: #2C3D4F; }
        .btn { display: inline-block; padding: 12px 30px; background: #8b0000; color: gold; text-decoration: none; border-radius: 5px; margin: 20px 0; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>New Deposit Confirmation</h1>
        </div>
        <div class="content">
          <p>A user has confirmed making a deposit on ${BRAND_NAME}.</p>
          
          <div class="info-box">
            <p><span class="label">User Name:</span> ${userData.fullName}</p>
            <p><span class="label">Email:</span> ${userData.email}</p>
            <p><span class="label">Amount:</span> $${amount}</p>
            <p><span class="label">Crypto:</span> ${paymentDetails.crypto}</p>
            <p><span class="label">Wallet Address:</span> ${paymentDetails.walletAddress}</p>
            <p><span class="label">Date:</span> ${paymentDetails.date}</p>
            <p><span class="label">Status:</span> ${paymentDetails.status}</p>
          </div>
          
          <div style="text-align: center;">
            <a href="${adminLink}" class="btn">Review Deposit</a>
          </div>
        </div>
      </div>
    </body>
    </html>
  `;
};

export const sendDepositNotificationEmail = async (userData, paymentDetails) => {
  console.log("📧 Sending deposit notification...", { SUPPORT_EMAIL, paymentDetails });
  try {
    const html = generateDepositNotificationHTML(userData, paymentDetails);
    const response = await emailjs.send(
      SERVICE_ID,
      TEMPLATE_ID,
      {
        user_name: "Admin",
        user_email: SUPPORT_EMAIL,
        html: html,
      },
      PUBLIC_KEY
    );
    console.log("✅ Deposit notification sent:", response);
    return true;
  } catch (error) {
    console.error("❌ Error sending deposit notification:", error);
    return false;
  }
};